/** @jsxRuntime classic */
import React from 'react';
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Puedes inicializar un nuevo proyecto con React simplemente corriendo este comando:`}</p>
    <div {...{
      "className": "remark-highlight"
    }}><pre parentName="div" {...{
        "className": "language-cli"
      }}><code parentName="pre" {...{
          "className": "language-cli"
        }}>{`npx create-react-app mi-nueva-aplicacion`}</code></pre></div>
    <p>{`Es un CLI que contiene Babel, Webpack y ESlint por debajo, aunque siempre puedes añadir configuraciones personalizadas con herramientas específicas.`}</p>
    <p>{`Sin embargo existen decenas de templates para comenzar a jugar con casi cualquier tecnología en segundos, puedes verlas, todas `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/search?q=cra-template-*&page=0&perPage=20"
      }}>{`aquí`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;